<template>
  <div class="page">
    <BookingBack title="Set Nickname" :textColor="'#333333'" :isCenter="true" />
    <div class="content">
      <van-field v-model="nickname" placeholder="Please enter nickname" clearable />
    </div>
    <div class="footer">
      <van-button block color="#1E3C3E" :loading="saving" @click="save">Save</van-button>
    </div>
  </div>
</template>
<script>
import BookingBack from '@/components/Booking/back.vue'
import { getUserDetail, updateUserInfo } from '@/api'
export default {
  name: 'AccountNickname',
  components: { BookingBack },
  data() {
    return { nickname: '', user: {}, saving: false }
  },
  created() {
    // 优先使用路由参数，否则回源请求
    const q = this.$route.query || {}
    this.nickname = q.nickname || ''
    this.fetch()
  },
  methods: {
    async fetch() {
      try {
        const res = await getUserDetail()
        if (res && res.code === 1 && res.data && res.data.userInfo) {
          this.user = res.data.userInfo
          if (!this.nickname) {
            this.nickname = this.user.nickName || ''
          }
        }
      } catch (e) {}
    },
    async save() {
      if (!this.nickname.trim()) {
        this.$toast && this.$toast('Please enter nickname')
        return
      }
      this.saving = true
      try {
        const res = await updateUserInfo({
          nickName: this.nickname,
          email: this.user.email || '',
          avatarUrl: this.user.avatarUrl || ''
        })
        if (res && res.code === 1) {
          this.$toast && this.$toast.success('Saved')
          this.$router.go(-1)
        } else {
          this.$toast && this.$toast.fail((res && res.msg) || 'Update failed')
        }
      } catch (e) {
        this.$toast && this.$toast.fail('Update failed')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page { min-height: 100vh; background: #f5f7fa; }
.content { padding: 1rem; }
.footer { position: fixed; left: 0; right: 0; bottom: 1rem; padding: 0 1rem; }
</style>
